import { render, staticRenderFns } from "./notice-close.vue?vue&type=template&id=ac1b61e4&scoped=true&"
import script from "./notice-close.vue?vue&type=script&lang=js&"
export * from "./notice-close.vue?vue&type=script&lang=js&"
import style0 from "./notice-close.vue?vue&type=style&index=0&id=ac1b61e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1b61e4",
  null
  
)

export default component.exports